import React from 'react';
import { motion } from 'framer-motion';
import { Globe, MessageCircle, Database, Calendar } from 'lucide-react';
const tools = [{
  label: 'Web',
  icon: Globe,
  rotate: -3,
  x: -8
}, {
  label: 'WhatsApp',
  icon: MessageCircle,
  rotate: 2,
  x: 6
}, {
  label: 'CRM',
  icon: Database,
  rotate: -2,
  x: -4
}, {
  label: 'Calendario',
  icon: Calendar,
  rotate: 3,
  x: 8
}];
export function Problem() {
  return <section className="bg-arena py-[72px] md:py-[120px]" data-id="element-166" data-mp="1jzpbqf5ezx15">
      <div className="max-w-[1200px] mx-auto px-6 md:px-20" data-id="element-167" data-mp="1k2bi4bgkk6hs">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center" data-id="element-168" data-mp="1oxqvl2ao00do">
          {/* Left: copy */}
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.4,
          ease: 'easeOut'
        }} data-id="element-169" data-mp="1a9ml2llrmv5z">
            <span className="block font-body text-[11px] uppercase font-medium text-salvia tracking-widest mb-6" data-id="element-170" data-mp="18q1tgdewz3ti">
              EL PROBLEMA
            </span>
            <h2 className="font-display text-[32px] md:text-[44px] font-bold text-carbon leading-[1.1] mb-6 max-w-[480px]" data-id="element-171" data-mp="1hidlu4tl91c4">
              Tu empresa ya tiene herramientas. El problema es que no
              trabajan juntas.
            </h2>
            <p className="font-body text-[16px] text-carbon/60 leading-[1.7] max-w-[440px] mb-6" data-id="element-172" data-mp="1regodbscr1zl">
              Una web genera interés. WhatsApp recibe mensajes. El CRM
              guarda contactos. El calendario organiza citas. Pero alguien
              termina conectando todo manualmente.
            </p>
            <p className="font-display text-[20px] font-bold text-verde" data-id="element-173" data-mp="1wd08r7ras5pu">
              ORIGEN conecta el proceso.
            </p>
          </motion.div>

          {/* Right: tools converging visual */}
          <div className="relative flex items-center justify-center h-[280px]" data-id="element-174" data-mp="236ecisfdt90">
            {tools.map((tool, idx) => {
            const Icon = tool.icon;
            const positions = ['top-2 left-4', 'top-2 right-4', 'bottom-2 left-4', 'bottom-2 right-4'];
            return <motion.div key={tool.label} initial={{
              opacity: 0,
              rotate: tool.rotate * 2,
              x: tool.x * 2,
              scale: 0.94
            }} whileInView={{
              opacity: 1,
              rotate: 0,
              x: 0,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.6,
              ease: [0.16, 1, 0.3, 1],
              delay: idx * 0.08
            }} className={`absolute ${positions[idx]} flex items-center gap-2 bg-arena border border-carbon/10 rounded-[12px] px-4 py-2.5 shadow-card`} data-id="element-175" data-mp="2g3vsbplu986e" data-mpi={idx}>
                  <span className="flex items-center justify-center w-7 h-7 rounded-full bg-verde/10 text-verde flex-shrink-0" data-id="element-176" data-mp="n71msiqpbpl2">
                    <Icon size={14} strokeWidth={2} data-id="element-177" data-mp="i99w1s1sm9ig" />
                  </span>
                  <span className="font-body text-[13px] font-medium text-carbon" data-id="element-178" data-mp="1ftmgvqykafsb">
                    {tool.label}
                  </span>
                </motion.div>;
          })}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true,
            amount: 0.4
          }} transition={{
            duration: 0.5,
            ease: 'easeOut',
            delay: 0.4
          }} className="relative z-10 flex items-center justify-center w-16 h-16 rounded-full bg-verde text-arena font-display font-bold text-[13px] shadow-cta" data-id="element-179" data-mp="163tcpb0r12y3">
              ORIGEN
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}